import React from "react";
import PropTypes from "prop-types";
import plusIcon from "../images/plus_filled.svg";
import emptyBasket from "../images/empty_basket.svg";

const ExmptyBasket = ({ onAddClick }) => {
  return (
    <div className="empty-widget-card bg-p400 my-3 ">
      <div className="empty-widget-content">
        <img
          src={emptyBasket}
          alt="Empty Basket"
          className="empty-widget-image"
        />

        <p className="empty-widget-text">
          There is no trade added yet to the basket
        </p>

        <button className="empty-widget-button" onClick={onAddClick}>
          <img src={plusIcon} alt="Add" className="plus-icon" />
          <span>Add new row</span>
        </button>
      </div>
    </div>
  );
};

ExmptyBasket.propTypes = {
  onAddClick: PropTypes.func.isRequired,
  addNewRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default ExmptyBasket;
